import { render, staticRenderFns } from "./create-or-edit-interface.vue?vue&type=template&id=23f670a9&scoped=true"
import script from "./create-or-edit-interface.vue?vue&type=script&lang=js"
export * from "./create-or-edit-interface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f670a9",
  null
  
)

export default component.exports